/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import { Page, View, Text, Document, StyleSheet, Font } from '@react-pdf/renderer';

// Registering fonts
Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/fonts/Roboto-Regular.ttf' },
    { src: '/fonts/Roboto-Bold.ttf', fontWeight: 700 },
  ],
});

// PropTypes
InvoicePDF.propTypes = {
  invoice: PropTypes.object.isRequired,
  MapData: PropTypes.array.isRequired,
};

// InvoicePDF Component
export default function InvoicePDF({ invoice, MapData }) {
  const { network, amount, plan_name, load_pin: loadPin } = invoice;

  const styles = StyleSheet.create({
    page: {
      padding: 5,
      fontSize: 8.58, // Decreased font size by 8%
      lineHeight: 1.1,
      fontFamily: 'Roboto',
      backgroundColor: '#fff',
      flexDirection: 'column',
    },
    row: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    card: {
      width: '18%', // Maintained width to fit exactly 5 cards per row
      padding: 3,
      marginBottom: 2,
      backgroundColor: 'white',
      border: '1px solid black',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    header: {
      marginBottom: 1,
      fontWeight: 'bold',
      fontSize: 8.58, // Decreased font size by 8%
      textAlign: 'center',
    },
    pin: {
      fontSize: 11.43, // Decreased font size by 8%
      fontWeight: 'bold',
      marginBottom: 2,
      textAlign: 'center',
    },
    text: {
      fontSize: 7.15, // Decreased font size by 8%
      fontWeight: 'bold',
      marginBottom: 1,
      textAlign: 'center',
    },
  });

  return (
    <Document>
      {Array.from({ length: Math.ceil(MapData.length / 50) }).map((_, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <View style={styles.row}>
            {MapData.slice(pageIndex * 50, (pageIndex + 1) * 50).map((card, index) => (
              <View key={index} style={styles.card}>
                <Text style={styles.header}>₦{amount} {network} {plan_name}</Text>
                <Text style={styles.pin}>PIN: {card?.pin}</Text>
                <Text style={styles.text}>Serial: {card?.serial}</Text>
                <Text style={styles.text}>To Load: {loadPin.toUpperCase()}</Text>
                <Text style={styles.text}>Balance: {card?.check_balance}</Text>
                <Text style={styles.text}>Whatsapp Care: 08064369609</Text>
                <Text style={styles.text}>Powered By Zenithdata</Text>
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
}
